import { useQuery } from '@tanstack/react-query';
import { getReferenceData, getReferenceDataByDirection } from '../../../api/v2/load';

export const useDropdownOptions = ({ movementType } = {}) => {
  return {
    staticDropdowns: useQuery({
      queryKey: ['referenceData'],
      queryFn: () => getReferenceData(),
      staleTime: Infinity,
    }),
    dropdownsByDirection: useQuery({
      queryKey: ['referenceDataByDirection', movementType],
      queryFn: () => getReferenceDataByDirection(movementType),
      enabled: !!movementType,
      staleTime: Infinity,
    }),
  };
};
